// Angular Library Imports
import { CommonModule } from '@angular/common';
// Custom Imports
import { HttpClientModule } from '@angular/common/http';
import { ModuleWithProviders,NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MaterialModule } from '../shared/material/material.module';
import { HttpService } from './http-service/http.service';
import { PageUnavailableComponent } from './page-unavailable/page-unavailable.component';



@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule   
  ],
  exports: [
    HttpClientModule  
  ],
  declarations: [
  PageUnavailableComponent,
    ]
})
export class CoreModule {
  static forRoot(): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: [
        HttpService
      ]
    };
  }
}
